module.exports = __webpack_public_path__ + "img/portraitMaleInfo.93da8e91.png";